<template>
  <v-dialog
    v-if="isOpened"
    v-model="isOpened"
    max-width="1000"
    scrollable
    persistent
    @click:outside="cancel"
    @keydown.esc="cancel"
    @keydown.enter="confirm"
  >
    <v-card>
      <v-card-title>
        Crop image
      </v-card-title>
      <v-card-text>
        <CropperWrapper
          ref="cropperwrapper"
          :mode="mode"
          :input-image-url="inputImageUrl"
          :aspect-ratio="aspectRatio"
          @cropped="cropped"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="cropImage"
        >
          Crop image
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="confirm"
          :disabled="isDisableConfirmButton"
          color="blue darken-1"
          text
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CropperWrapper from '../CropperWrapper.vue';

export default {
  name: 'CropperDialog',
  components: {
    CropperWrapper,
  },

  props: {
    mode: {
      type: String,
      default: 'min',
    },
  },

  data: () => ({
  }),

  methods: {
    ...mapActions({
      closeCropperDialog: 'micrositeCropperDialog/closeCropperDialog',
      setOutputImageStr: 'micrositeCropperDialog/setOutputImageStr',
      updateElement: 'microsite/updateElement',
    }),

    cropped(imageString) {
      this.setOutputImageStr(imageString);
    },

    cropImage() {
      this.$refs.cropperwrapper.cropImage();
    },

    cancel() {
      this.closeCropperDialog();
    },

    confirm() {
      if (this.isDisableConfirmButton) {
        return false;
      }

      const element = JSON.parse(
        JSON.stringify(this.element(this.rowIndex, this.elementIndex)),
      );

      element.cropped = this.outputImageStr;

      this.updateElement({
        rowIndex: this.rowIndex,
        elementIndex: this.elementIndex,
        newElementData: element,
      });

      this.closeCropperDialog();

      return true;
    },
  },

  computed: {
    ...mapGetters({
      isOpened: 'micrositeCropperDialog/isOpened',
      isExistOutputImageStr: 'micrositeCropperDialog/isExistOutputImageStr',
      inputImageUrl: 'micrositeCropperDialog/inputImageUrl',
      outputImageStr: 'micrositeCropperDialog/outputImageStr',
      rowIndex: 'micrositeCropperDialog/rowIndex',
      elementIndex: 'micrositeCropperDialog/elementIndex',
      aspectRatio: 'micrositeCropperDialog/aspectRatio',
      element: 'microsite/element',
    }),

    isDisableConfirmButton() {
      return !this.isExistOutputImageStr;
    },
  },
};
</script>
